export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/t_shirts_merchandise.f0ef466.svg";